import * as Connector from 'shared/connectors/startConnector';
import { START } from 'store/types';

const init = () => ({
  type: START.GET_OFFERS_INIT,
});

const success = data => ({
  type: START.GET_OFFERS_SUCCESS,
  payload: {
    data,
  },
});

const failure = () => ({
  type: START.GET_OFFERS_FAILURE,
});

const getOffers = () => async dispatch => {
  dispatch(init());
  try {
    const { data } = await Connector.getOffers();
    dispatch(success(data));
  } catch (err) {
    dispatch(failure());
  }
};

export default getOffers;
